"use client"

import { useEffect, useMemo } from 'react'
import { MapContainer, TileLayer, Marker, Popup, useMap } from 'react-leaflet'
import 'leaflet/dist/leaflet.css'
import L from 'leaflet'
import markerIcon2x from 'leaflet/dist/images/marker-icon-2x.png'
import markerIcon from 'leaflet/dist/images/marker-icon.png'
import markerShadow from 'leaflet/dist/images/marker-shadow.png'

// Fix default icon paths for Leaflet in Next bundler
delete L.Icon.Default.prototype._getIconUrl
L.Icon.Default.mergeOptions({
  iconRetinaUrl: markerIcon2x.src || markerIcon2x,
  iconUrl: markerIcon.src || markerIcon,
  shadowUrl: markerShadow.src || markerShadow,
})

function FitBounds({ bounds }){
  const map = useMap()
  useEffect(()=>{
    if(!bounds || bounds.length === 0) return
    try{
      map.fitBounds(bounds, { padding: [40,40] })
    }catch(e){}
  }, [map, bounds])
  return null
}

export default function CityMap({ parks }){
  // parks debe ser parks_with_coords (ya normalizado)
  const markers = useMemo(() => {
    return (parks || [])
      .map(p => {
        const lat = parseFloat(p.lat)
        const lng = Number.isFinite(p.lng) ? parseFloat(p.lng) : undefined
        if (Number.isFinite(lat) && Number.isFinite(lng)) {
          return { ...p, lat, lng }
        }
        return null
      })
      .filter(Boolean)
  }, [parks])

  const bounds = useMemo(()=>{
    if(!markers.length) return null
    return markers.map(m => [m.lat, m.lng])
  }, [markers])

  const center = markers.length ? [markers[0].lat, markers[0].lng] : [39.4699, -0.3763]

  return (
    <div style={{ marginBottom: '1rem' }}>
      <MapContainer center={center} zoom={13} style={{ height: 'clamp(200px, 40vh, 420px)', width: '100%' }}>
        {/* Attribution is REQUIRED: the OSMF tile policy says "Show OpenStreetMap licence
            attribution clearly on the map", and the whole dataset is OSM-derived (ODbL).
            This map shipped with none. */}
        <TileLayer
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
          attribution='&copy; <a href="https://www.openstreetmap.org/copyright" target="_blank" rel="noopener noreferrer">OpenStreetMap</a> contributors'
        />
        {markers.map(m => (
          <Marker key={m.id || `${m.lat}-${m.lng}`} position={[m.lat, m.lng]}>
            <Popup>
              <div>
                <strong>{m.name}</strong>
                {m.source_url ? (
                  <div><a href={m.source_url} target="_blank" rel="noreferrer">fuente</a></div>
                ) : null}
              </div>
            </Popup>
          </Marker>
        ))}
        {bounds && <FitBounds bounds={bounds} />}
      </MapContainer>
    </div>
  )
}
